
import * as Yup from 'yup';

export const letterSchema = Yup.object().shape({
  recipientName: Yup.string()
    .required('Recipient name is required')
    .min(2, 'Name must be at least 2 characters'),
  recipientEmail: Yup.string()
    .required('Email address is required')
    .email('Invalid email address')
    .nullable()
    .transform((curr, orig) => (orig === "" ? null : curr)), // Allow empty strings if optional
  recipientAddress: Yup.string()
    .required('Address is required')
    .min(5, 'Address must be at least 5 characters'),
  subject: Yup.string()
    .required('Subject is required'),
  body: Yup.string()
    .required('Letter body cannot be empty')
    .min(10, 'Body must be at least 10 characters long'),
  // status: Yup.string()
  //   .oneOf(['Sent', 'Pending', 'Draft'], 'Invalid status')
  //   .optional()
});

// Helper to extract errors from a Yup Validation Error object
export const extractErrors = (err: any) => {
  const newErrors: Record<string, string> = {};

  // Check if it's a Validation Error with multiple inner errors
  if (err?.inner && Array.isArray(err.inner)) {
    err.inner.forEach((error: any) => {
      if (error.path) {
        newErrors[error.path] = error.message;
      }
    });
  }
  // Fallback: If it's a single error without inner array
  else if (err?.path && err?.message) {
    newErrors[err.path] = err.message;
  }
  // Fallback: Generic error (optional)
  else {
    console.error("Non-validation error caught:", err);
  }

  return newErrors;
};